// Problem-Solving and Data Analysis reference sheet — quick-lookup formulas
// and rules, as opposed to the instructional walkthroughs with worked
// examples in the Math domain guide. Keep entries short: a formula or rule,
// not a lesson. Paragraphs are plain strings or structured blocks
// { type: 'list', ... }.

export const documentTitle = 'Problem-Solving and Data Analysis Reference';
export const documentSlug = 'problem-solving-data-analysis-reference';

export const parts = [
  {
    id: 'psda-reference-full',
    title: null,
    sections: [
      {
        id: 'psdar-ratios-units',
        heading: 'Ratios, Rates, and Unit Conversion',
        paragraphs: [
          'Set up a proportion with matching units in the same position on both sides, then cross-multiply. For unit conversion, multiply by a conversion factor written as a fraction so the unwanted unit cancels out.',
        ],
      },
      {
        id: 'psdar-percent-change',
        heading: 'Percent Change',
        paragraphs: [
          'Percent change = (new value - old value) / old value × 100.',
          {
            type: 'list',
            items: ['To increase by a percent, multiply by (1 + rate).', 'To decrease, multiply by (1 - rate).'],
          },
          "Successive percent changes compound — they don't simply add together.",
        ],
      },
      {
        id: 'psdar-center-spread',
        heading: 'Center and Spread',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Mean = sum of values / number of values — easily pulled toward outliers',
              'Median = the middle value once sorted — resistant to outliers',
              'Range = maximum - minimum',
            ],
          },
        ],
      },
      {
        id: 'psdar-correlation',
        heading: 'Correlation and Lines of Best Fit',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Positive correlation: both variables increase together',
              'Negative correlation: one increases as the other decreases',
              'No correlation: no consistent pattern',
            ],
          },
          'To use a line of best fit given as an equation, substitute the given value and solve for the other variable.',
        ],
      },
      {
        id: 'psdar-probability',
        heading: 'Probability',
        paragraphs: [
          'Probability = favorable outcomes / total outcomes. From a two-way table, divide the relevant cell by the appropriate row, column, or grand total.',
        ],
      },
      {
        id: 'psdar-study-design',
        heading: 'Study Design',
        paragraphs: [
          {
            type: 'list',
            items: [
              'An observational study can show that two things are associated, but not that one causes the other.',
              'A randomized controlled experiment, with participants randomly assigned to groups, can support a claim of cause and effect.',
              'Random sampling supports generalizing results to a population; random assignment supports a causal conclusion.',
            ],
          },
        ],
      },
    ],
  },
];
